module.exports = __webpack_public_path__ + "static/media/500.a621f335.svg";